import { Box, Stack } from '@mui/material';
import Navbar from './Navbar';
import { Outlet } from 'react-router';
import { UserStatusContextProvider } from '../../contexts';

interface DashboardLayoutProps {
  viewMode: 'admin' | 'clinician';
}

export default function DashboardLayout({ viewMode }: DashboardLayoutProps) {
  return (
    <UserStatusContextProvider>
      <Box sx={{ height: '100%' }}>
        <Stack sx={{ height: '100%' }}>
          <Navbar viewMode={viewMode} />
          <Outlet />
        </Stack>
      </Box>
    </UserStatusContextProvider>
  );
}
